import React from "react";
import { Card } from "@tremor/react";
import { Link } from "react-router-dom";
const Challenges = () => {
  return (
    <div className="w-full flex-grow p-3">
      <div>Navbar</div>
      <div className="w-full grid grid-cols-12 mt-5">
        <div className="col-span-12 md:col-span-6 lg:col-span-4">
          <div className="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <Link to="/visit">
              <img
                className="rounded-t-lg h-52 w-full object-cover"
                src={
                  "https://www.lifewire.com/thmb/YBQuRMKxxhx3Zb3uJ1x-QOT6VsM=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Maplocation_-5a492a4e482c52003601ea25.jpg"
                }
                alt={"visit"}
              />
            </Link>
            <div className="p-5 min-h-48">
              <Link to="/visit">
                <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  Visit
                </h5>
              </Link>
              <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                Explore the hidden wonders of an ancient forest, where towering
                trees whisper secrets of ages past and dappled sunlight dances
                upon moss-covered paths. Venture deep into the heart of nature's
                embrace and uncover the mysteries that lie within.
              </p>
            </div>
          </div>
        </div>
        <div className="col-span-12 md:col-span-6 lg:col-span-4">
          <div className="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <Link to="/challenges-menu">
              <img
                className="rounded-t-lg h-52 w-full object-cover"
                src={
                  "https://img.freepik.com/free-photo/air-caucasian-professional-male-athlete-runner-training-isolated-white-background_155003-32543.jpg?w=1060&t=st=1709086508~exp=1709087108~hmac=4a1cfb43c816a40fc25e26f71b383c57a2b46d0cfb606d4040f49325893284bd"
                }
                alt={"challenges-menu"}
              />
            </Link>
            <div className="p-5 min-h-48">
              <Link to="/visit">
                <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                  Challenges
                </h5>
              </Link>
              <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                Explore the hidden wonders of an ancient forest, where towering
                trees whisper secrets of ages past and dappled sunlight dances
                upon moss-covered paths. Venture deep into the heart of nature's
                embrace and uncover the mysteries that lie within.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Challenges;
